import { useTranslation } from "@coworker/locales";
import { InsufficientHfb } from "@coworker/types/lib/testbuy_api";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaPrompt } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaPrompt";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import styled from "styled-components";

interface InsufficientHfbModalProps {
  insufficientHfbs: InsufficientHfb[];
  numberOfArticles: number;
  onClose: () => void;
}

const BodyParagraph = styled("p")`
  margin-bottom: 16px;
`;

export function InsufficientHfbModal({
  insufficientHfbs,
  numberOfArticles,
  onClose,
}: InsufficientHfbModalProps) {
  const { t } = useTranslation();

  const hfbLabels = insufficientHfbs
    .map((h) => (h.hfb ? `HFB ${h.hfb}` : t("wholeStoreString")))
    .join(" and ");

  const articleCounts = `${numberOfArticles} articles available for ${hfbLabels}`;

  return (
    <FixaModal visible={true} handleCloseBtn={onClose}>
      <FixaPrompt
        title={
          <>
            {t("noMoreArticlesAvailableString")}
            <br />
            {hfbLabels}
          </>
        }
        titleId="insufficient-hfb-modal"
        header={<FixaModalHeader title={""} ariaCloseTxt={t("closeString")} />}
        footer={
          <FixaModalFooter>
            <FixaButton
              text={t("okIUnderstandString")}
              type="primary"
              onClick={onClose}
            />
          </FixaModalFooter>
        }
      >
        <BodyParagraph>{t("noMoreArticlesForHfbBody1")}</BodyParagraph>
        <BodyParagraph>
          {t("noMoreArticlesForHfbBody2", { articleCounts })}
        </BodyParagraph>
        <BodyParagraph>{t("noMoreArticlesForHfbBody3")}</BodyParagraph>
      </FixaPrompt>
    </FixaModal>
  );
}
